import { render } from "./TablePriceView.vue?vue&type=template&id=72463750"
import script from "./TablePriceView.vue?vue&type=script&lang=js"
export * from "./TablePriceView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__